import { Outlet } from "react-router-dom"

import Layout from "components/navigation/Layout";
import Icons from "components/ui/Icons";

import NotFound from "screens/global/NotFound";
import AgentHome from "screens/agent/AgentHome";
import TenantVehicle from "screens/tenant/vehicle/TenantVehicle";
import TenantVehicles from "screens/tenant/vehicle/TenantVehicles";
import TenantClients from "screens/tenant/client/TenantClients";
import TenantClient from "screens/tenant/client/TenantClient";
import TenantClientLicense from "screens/tenant/client/TenantClientLicense";
import TenantClientInsurance from "screens/tenant/client/TenantClientInsurance";

import DynamicClientBreadCrumb from "components/tenant/client/DynamicClientBreadCrumb";
import DynamicVehicleBreadCrumb from "components/tenant/vehicle/DynamicVehicleBreadcrumb";
import TenantOrders from "screens/tenant/order/TenantOrders";
import TenantOrderProcess from "screens/tenant/order/TenantOrderProcess";
import DynamicOrderBreadCrumb from "components/tenant/order/DynamicOrderBreadcrumb";
import TenantOrderDetails from "screens/tenant/order/TenantOrderDetails";
import TenantOrderOverview from "screens/tenant/order/TenantOrderOverview"; 
import TenantOrderFiles from "screens/tenant/order/TenantOrderFiles";

let agentRoutes = {
    routes: [
        {
            path: '/',
            element: <Layout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <AgentHome />, breadcrumb: 'Home' },
                {
                    path: "clients",
                    element: <Outlet />,
                    breadcrumb: 'Clients',
                    icon: 'clients',
                    children: [
                        { index: true, element: <TenantClients /> },
                        { 
                            path: ":id", 
                            element: <Outlet />,
                            children: [
                                { index: true, element: <TenantClient />, breadcrumb: DynamicClientBreadCrumb },
                                { path: "license", element: <TenantClientLicense />, breadcrumb: 'License' },
                                { path: "insurance", element: <TenantClientInsurance />, breadcrumb: 'Insurance' },
                            ]
                        }
                    ] 
                },
                {
                    path: "vehicles",
                    element: <Outlet />,
                    breadcrumb: 'Vehicles',
                    icon: 'vehicles',
                    children: [
                        { index: true, element: <TenantVehicles /> },
                        { path: ":id", element: <TenantVehicle />, breadcrumb: DynamicVehicleBreadCrumb }
                    ]
                },
                {
                    path: "orders",
                    element: <Outlet />,
                    breadcrumb: 'Orders',
                    icon: 'orders',
                    children: [
                        { index: true, element: <TenantOrders/> },
                        { 
                            path: ":id", 
                            element: <Outlet />,
                            children: [
                                { index: true, element: <TenantOrderOverview />, breadcrumb: DynamicOrderBreadCrumb },
                                { path: "details", element: <TenantOrderDetails />, breadcrumb: "Details" },
                                { path: "files", element: <TenantOrderFiles/>, breadcrumb: "Files" },
                                { path: "process", element: <TenantOrderProcess />, breadcrumb: 'Process' },
                            ]
                        }
                    ]
                },
                { path: "*", element: <NotFound />, breadcrumb: 'Page Not Found', }
            ]
        }
    ],
    menu: [
        {
            to: '/',
            label: "Home",
            icon: Icons.home
        },
        {
            to: '/orders',
            label: "Orders",
            icon: Icons.orders
        },
        {
            to: '/vehicles',
            label: "Vehicles",
            icon: Icons.vehicles
        },
        {
            to: '/clients',
            label: "Clients",
            icon: Icons.clients
        }
    ],
    mobile: [
        {
            to: '/',
            label: "Home",
            icon: Icons.home
        },
        {
            to: '/orders',
            label: "Orders",
            icon: Icons.orders
        },
        {
            to: '/vehicles',
            label: "Vehicles",
            icon: Icons.vehicles
        },
        {
            to: '/clients',
            label: "Clients",
            icon: Icons.clients
        }
    ]
}

export default agentRoutes;